exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.working-pad[data-v-79c18860] {\n    max-width: 100%;\n    max-height: 720px;\n    margin-bottom: 12px;\n    overflow-y: auto;\n}\n", ""]);

// exports
